const BurgerMenu = (props) => (
  <svg
    width={22}
    height={16}
    viewBox='0 0 22 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.1538 1.97368H0.846154C0.38359 1.97368 0 1.52632 0 0.986842C0 0.447368 0.38359 0 0.846154 0H21.1538C21.6164 0 22 0.447368 22 0.986842C22 1.52632 21.6164 1.97368 21.1538 1.97368Z'
      fill='currentColor'
    />
    <path
      d='M21.1538 8.55263H0.846154C0.38359 8.55263 0 8.10526 0 7.56578C0 7.02631 0.38359 6.57894 0.846154 6.57894H21.1538C21.6164 6.57894 22 7.02631 22 7.56578C22 8.10526 21.6164 8.55263 21.1538 8.55263Z'
      fill='currentColor'
    />
    <path
      d='M21.1538 15.1316H0.846154C0.38359 15.1316 0 14.6842 0 14.1447C0 13.6052 0.38359 13.1579 0.846154 13.1579H21.1538C21.6164 13.1579 22 13.6052 22 14.1447C22 14.6842 21.6164 15.1316 21.1538 15.1316Z'
      fill='currentColor'
    />
  </svg>
);
export default BurgerMenu;
